// @flow
import React, { PureComponent } from "react";
import SearchForm from "containers/SearchForm";
import { type SearchItemDTO, type SearchResultRowDTO } from "data/types";
import loc from "i18next";
import SearchResultContainer from "containers/SearchResult";
import Split from "split.js";
import styles from "./ArchiveTargetSearchForm.module.css";
import { getClassNames } from "data/utils";

type Props = {
    /** searchForm id to render */
    id: number,
    /** callback when target found
     * @param {string} targetItemUri target's itemUri to archive onto
     */
    onTargetItemUri: (targetItemUri: string) => void,
    /** callback when user clicks the Cancel button */
    onCancel: () => void,
};

type State = {
    searchItem: ?SearchItemDTO,
};

export class ArchiveTargetSearchForm extends PureComponent<Props, State> {
    splitView: Split;
    state = {
        searchItem: null,
    };

    componentDidMount() {
        this.splitView = Split(
            [`.${styles.searchPanel}`, `.${styles.searchResult}`],
            {
                sizes: [100, 0],
                direction: "vertical",
                minSize: 0,
                gutterSize: 10,
                elementStyle: /* istanbul ignore next */ (
                    dimension,
                    size,
                    gutterSize
                ) => {
                    return {
                        "flex-basis":
                            "calc(" + size + "% - " + gutterSize + "px)",
                    };
                },
                gutterStyle: /* istanbul ignore next */ (
                    dimension,
                    gutterSize
                ) => {
                    return { "flex-basis": gutterSize + "px" };
                },
            }
        );
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        if (this.props.id !== prevProps.id) {
            this.setState({ searchItem: null });
        }
        if (this.state.searchItem !== prevState.searchItem) {
            if (this.state.searchItem == null) {
                this.splitView.setSizes([0, 100]);
            } else {
                this.splitView.setSizes([30, 70]);
            }
        }
    }

    _onSearch = (searchItem: SearchItemDTO) => this.setState({ searchItem });

    _onSearchFormSetTarget = (
        activeRowIndex: number,
        row?: SearchResultRowDTO
    ) => {
        if (activeRowIndex !== -1 && row != null) {
            this.setState({ searchItem: null });
            /* istanbul ignore else */
            if (typeof this.props.onTargetItemUri === "function")
                this.props.onTargetItemUri(
                    // take itemUri without EID
                    row.breadcrumb.parts[row.breadcrumb.parts.length - 1]
                        .itemUri
                );
        }
        return false;
    };

    render = () => (
        <div className={getClassNames(styles.wrapper, styles.fSplit)} data-test="archiveTargetSearchForm">
            <div className={styles.searchPanel}>
                <SearchForm
                    id={this.props.id}
                    // itemUri={this.state.selectedArchiveTarget.itemUri}
                    searchLabel={loc.t("upload:archivetarget.search")}
                    searchEnabled={true}
                    onSearch={this._onSearch}
                    onCancel={this.props.onCancel}
                // extraFilters={[
                //     {
                //         name: "ItemType",
                //         value: "Folder",
                //         op: SearchOperator.Equals,
                //         valueType: SearchValueType.ItemType
                //     }
                // ]}
                />
            </div>
            <div className={styles.searchResult}>
                {this.state.searchItem && (
                    <SearchResultContainer
                        isBreadcrumbReadonly={true}
                        showFilterBar={true}
                        searchItem={this.state.searchItem}
                        onSetActiveRowIndex={this._onSearchFormSetTarget}
                        onAutoBrowseToItem={this._onSearchFormSetTarget}
                        isMoreHidden={true}
                    />
                )}
            </div>
        </div>
    );
}
export default ArchiveTargetSearchForm;
